import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') throw err
  })
}

const Login = () => import('../views/common/Login.vue')
const Register = () => import('../views/common/Register.vue')
const AppLayout = () => import('../components/AppLayout.vue')

// 学生端页面
const StudentHome = () => import('../views/student/Home.vue')
const StudentDiagnosis = () => import('../views/student/Diagnosis.vue')
const StudentPortrait = () => import('../views/student/Portrait.vue')
const StudentTraining = () => import('../views/student/Training.vue')
const StudentProgress = () => import('../views/student/Progress.vue')
const StudentGrowthMap = () => import('../views/student/GrowthMap.vue')
const StudentTaskPool = () => import('../views/student/TaskPool.vue')
const StudentHistory = () => import('../views/student/History.vue')
const StudentVocabulary = () => import('../views/student/Vocabulary.vue')
const StudentGrammar = () => import('../views/student/Grammar.vue')
const StudentReading = () => import('../views/student/Reading.vue')
const StudentDetectionResult = () => import('../views/student/DetectionResult.vue')
const StudentMyLevels = () => import('../views/student/MyLevels.vue')

// 教师端页面
const TeacherHome = () => import('../views/teacher/Home.vue')
const TeacherStudentList = () => import('../views/teacher/StudentList.vue')
const TeacherStudentDetail = () => import('../views/teacher/StudentDetail.vue')
const TeacherPortraitView = () => import('../views/teacher/PortraitView.vue')
const TeacherSuggestion = () => import('../views/teacher/Suggestion.vue')
const TeacherMaterial = () => import('../views/teacher/Material.vue')
const TeacherTaskMonitor = () => import('../views/teacher/TaskMonitor.vue')

// 后台系统页面
const AdminHome = () => import('../views/admin/Home.vue')
const AdminStudentManage = () => import('../views/admin/StudentManage.vue')
const AdminStudyPlanGen = () => import('../views/admin/StudyPlanGen.vue')
const AdminTaskSchedule = () => import('../views/admin/TaskSchedule.vue')
const AdminRuleConfig = () => import('../views/admin/RuleConfig.vue')
const AdminVocabularyBook = () => import('../views/admin/VocabularyBook.vue')
const AdminQuestionBank = () => import('../views/admin/QuestionBank.vue')
const AdminKnowledgeBase = () => import('../views/admin/KnowledgeBase.vue')
const AdminContentReview = () => import('../views/admin/ContentReview.vue')
const AdminExportPublish = () => import('../views/admin/ExportPublish.vue')
const AdminSystemLog = () => import('../views/admin/SystemLog.vue')
const AdminExamGenerator = () => import('../views/admin/ExamGenerator.vue')
const AdminReadingMaterialAdmin = () => import('../views/admin/ReadingMaterialAdmin.vue')
const AdminQuestionSubTypeConfig = () => import('../views/admin/QuestionSubTypeConfig.vue')
const AdminStudentLevelOverview = () => import('../views/admin/StudentLevelOverview.vue')

const routes = [
  { path: '/login', name: 'Login', component: Login },
  { path: '/register', name: 'Register', component: Register },
  { path: '/student', component: AppLayout, children: [
    { path: '', name: 'StudentHome', component: StudentHome },
    { path: 'diagnosis', name: 'StudentDiagnosis', component: StudentDiagnosis },
    { path: 'portrait', name: 'StudentPortrait', component: StudentPortrait },
    { path: 'training', name: 'StudentTraining', component: StudentTraining },
    { path: 'progress', name: 'StudentProgress', component: StudentProgress },
    { path: 'growth-map', name: 'StudentGrowthMap', component: StudentGrowthMap },
    { path: 'task-pool', name: 'StudentTaskPool', component: StudentTaskPool },
    { path: 'history', name: 'StudentHistory', component: StudentHistory },
    { path: 'vocabulary', name: 'StudentVocabulary', component: StudentVocabulary },
    { path: 'detection-result/:detectionId', name: 'StudentDetectionResult', component: StudentDetectionResult },
    { path: 'reading', name: 'StudentReading', component: StudentReading },
    { path: 'grammar', name: 'StudentGrammar', component: () => import('@/views/student/Grammar.vue') },
    { path: 'my-levels', name: 'StudentMyLevels', component: StudentMyLevels }
  ]},
  { path: '/teacher', component: AppLayout, children: [
    { path: '', name: 'TeacherHome', component: TeacherHome },
    { path: 'students', name: 'TeacherStudentList', component: TeacherStudentList },
    { path: 'student/:id', name: 'TeacherStudentDetail', component: TeacherStudentDetail },
    { path: 'portrait/:studentId', name: 'TeacherPortraitView', component: TeacherPortraitView },
    { path: 'suggestion', name: 'TeacherSuggestion', component: TeacherSuggestion },
    { path: 'material', name: 'TeacherMaterial', component: TeacherMaterial },
    { path: 'task-monitor', name: 'TeacherTaskMonitor', component: TeacherTaskMonitor },
    { path: 'grammar', name: 'TeacherGrammarView', component: () => import('@/views/teacher/GrammarTeacherView.vue') }
  ]},
  { path: '/admin', component: AppLayout, children: [
    { path: '', name: 'AdminHome', component: AdminHome },
    { path: 'students', name: 'AdminStudentManage', component: AdminStudentManage },
    { path: 'generate', name: 'AdminStudyPlanGen', component: AdminStudyPlanGen },
    { path: 'task-schedule', name: 'AdminTaskSchedule', component: AdminTaskSchedule },
    { path: 'rule-config', name: 'AdminRuleConfig', component: AdminRuleConfig },
    { path: 'vocab-book', name: 'AdminVocabularyBook', component: AdminVocabularyBook },
    { path: 'question-bank', name: 'AdminQuestionBank', component: AdminQuestionBank },
    { path: 'knowledge', name: 'AdminKnowledgeBase', component: AdminKnowledgeBase },
    { path: 'content-review', name: 'AdminContentReview', component: AdminContentReview },
    { path: 'export', name: 'AdminExportPublish', component: AdminExportPublish },
    { path: 'system-log', name: 'AdminSystemLog', component: AdminSystemLog },
    { path: 'exam-generator', name: 'AdminExamGenerator', component: AdminExamGenerator },
    { path: 'reading-materials', name: 'AdminReadingMaterialAdmin', component: AdminReadingMaterialAdmin },
    { path: 'grammar-admin', name: 'AdminGrammarAdmin', component: () => import('@/views/admin/GrammarAdmin.vue') },
    { path: 'question-sub-type-config', name: 'AdminQuestionSubTypeConfig', component: AdminQuestionSubTypeConfig },
    { path: 'student-levels', name: 'AdminStudentLevelOverview', component: AdminStudentLevelOverview }
  ]},
  { path: '/', redirect: '/login' }
]

const router = new VueRouter({ routes })

router.beforeEach((to, from, next) => {
  const isLoggedIn = store.getters.isLoggedIn
  const userType = store.state.userType
  if (to.path === '/login' || to.path === '/register') {
    next()
  } else if (!isLoggedIn) {
    next('/login')
  } else if (userType === 0) {
    next('/login')
  } else {
    const path = to.path
    if (path.startsWith('/student') && userType !== 1) {
      next(userType === 2 ? '/teacher' : '/admin')
    } else if (path.startsWith('/teacher') && userType !== 2) {
      next(userType === 1 ? '/student' : '/admin')
    } else if (path.startsWith('/admin') && userType !== 3) {
      next(userType === 1 ? '/student' : '/teacher')
    } else {
      next()
    }
  }
})

export default router